'use client'

import CometLink from '@app/components/custom-links/comet-link'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import clsx from 'clsx'
import Image from 'next/image'

interface Props {
  className?: string
  src: string
}

const LogoClient = ({className, src}: Props) => {
  return (
    <CometLink href='/' className={clsx(className)} onClick={() => triggerAnalytics('footer-logo-clicked').sendAll()}>
      <Image fill alt='Company logo' className='object-contain' src={src} />
    </CometLink>
  )
}

export default LogoClient
